import React, { Component } from "react";
import { Link } from "react-router-dom";
import "./Header.css";

import Logo from "../assets/img/LogoMakr-4Km0B6.png";

export default class Header extends Component {
  render() {
    return (
      <header>
        <div className="container pl-0 h-100">
          <div className="d-flex justify-content-between align-items-center h-100">
            <div className="left">
              <form
                // onSubmit={this.search}
                className="d-flex nav-search h-100 align-items-center"
              >
                <img
                  src={Logo}
                  className="img_fluid nav_profile mr-2"
                  alt="User Profile picture"
                  title="Your profile picture"
                />
                <button className="btn">
                  <i className="fas fa-search"></i>
                </button>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Search . . ."
                />
              </form>
            </div>
            <div className="middle">
              <Link to="/" className="logo">
                <img
                  // Profile
                  src={Logo}
                  alt="Logo"
                  title="beautyhand logo"
                  className="logo-middle"
                />
              </Link>
            </div>
            <div className="right d-flex justify-content-end">
              <Link to="/" className="mr-3 nav_links active">
                <i className="fas fa-home fa-lg" title="Home"></i>
                {/* <span className="ml-1">Home</span> */}
              </Link>
              <Link
                to="/notifications"
                className="mr-3 nav_links"
                title="Notifications"
              >
                <i className="far fa-bell fa-lg"></i>
                {/* <span className="ml-1">Notification</span> */}
              </Link>
              <Link to="/messages" className="mr-3 nav_links" title="Messages">
                <i className="far fa-comment-alt fa-lg"></i>
                {/* <span className="ml-1">Messages</span> */}
              </Link>
              <Link to="/profile" className="nav_links">
                <i className="far fa-user fa-lg"></i>
                <span className="ml-1">
                  {/* {"Hello, " + this.props.user.user_name} */}
                </span>
              </Link>
            </div>
          </div>
        </div>
        <div className="preloader"></div>
      </header>
    );
  }
}
